
import { Component, Prop, Vue } from 'vue-property-decorator'

import BacEditableImage from './BacEditableImage.vue'

@Component({
  components: {
    BacEditableImage
  }
})
export default class BacEditableMinioImage extends Vue {
  @Prop({ required: true }) bucket!: string;
  @Prop({ required: true }) imagePath!: string;
  @Prop({ default: false }) editMode!: boolean;
  @Prop({ required: false, default: false }) onlyEmitDelete!: boolean;
  @Prop({ default: null }) id!: number | null
  @Prop({ required: false, default: false }) legacy!: boolean;

  emitSaved (data: any) {
    this.$emit('saved', data)
  }
}
